(function ($, Promise) {

    // Constructor
    function VICCWhatNow() {
      // console.log("VICCWhatNow: constructor()");

      this.share = new VICCVisualizeShare();
    }

    VICCWhatNow.prototype.attach = function (dom) {
      // console.log("VICCWhatNow: attach()");

      this.share.attach();

      app.components.visualize.initSwiper();

    }

    VICCWhatNow.prototype.submitReminderForm = function () {
      $("#visualize-share-submit").addClass("disabled");

      var email = $("#visualize-share-email").val();
      var address = (app.currentComponent.placename) ? app.currentComponent.placename : "";
      if (email == "") {
        this.showMessage("#visualize-share-submit-missing-email")
        return;
      }

      var delay = 0;
      if ($("#visualize-share-3months").is(':checked')) {
        delay = 3;
      } else if ($("#visualize-share-6months").is(':checked')) {
        delay = 6;
      }

      var imageHash = (app.currentComponent.share) ? app.currentComponent.share.currentHash : false;

      grecaptcha.ready($.proxy(function () {
        grecaptcha.execute(recaptcha_key, {action: 'submit'}).then($.proxy(function (token) {
          // Send request to API
          jqxr = $.ajax({
            type: "POST",
            url: "/api/reminder",
            data: {
              token: token,
              email: email,
              delay: delay,
              address: address,
              imageHash: imageHash,
              language: app.language,
            },
            dataType: 'json'
          }).then($.proxy(function (responseJSON) {
            if (responseJSON.savedId) {
              this.showMessage("#visualize-share-submit-success")
            } else {
              this.showMessage("#visualize-share-submit-error")
            }

          }, this)).catch($.proxy(function (err) {
            this.showMessage("#visualize-share-submit-error")

          }, this));
        }, this));
      }, this));
    }

    VICCWhatNow.prototype.showMessage = function (id) {
      var tl = gsap.timeline();

      // Animation
      tl.to(id, 0.5, {
        opacity: 1,
      });
      tl.to(id, 0.5, {
        opacity: 0,
      }, "+=1.5");
      tl.add(function () {
        $("#visualize-share-submit").removeClass("disabled");
      });
    }

    VICCWhatNow.prototype.dettach = function () {
      // console.log("VICCWhatNow: dettach()");

      $(window).off("resize");

      this.share.dettach();
    }

    // Expose VICCWhatNow
    window.VICCWhatNow = VICCWhatNow;

  }
)
(jQuery, Promise);
